<template>
  <span class="error">{{ props.text }}</span>
</template>

<script setup lang="ts">
interface Props {
  text: string;
}

const props = defineProps<Props>();
</script>

<style scoped>
.error {
  color: #b71b1a;
}

.error::before {
  content: '';
  display: inline-block;
  width: 16px;
  height: 18px;
  padding-left: 16px;
  /* TODO:  */
  background-image: url('@/assets/img/error-red.svg');
  background-repeat: no-repeat;
  background-size: contain;
  vertical-align: middle;
  margin-right: 4px;
  margin-bottom: 2px;
}
</style>
